import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './visitsToConfirmCard.module.scss';
import PropertyData from '../../PendingEvents/PropertyData';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import TimeStatusIndicator from '../../TimeStatusIndicator';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import { toggleEditModal } from '@/store/slices/components/calendarEvents/CalendarEventsSlice';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import { getVisitScheduleDisplay } from '../../utils';

function VisitsToConfirmCard({ visit, trackCallback = null }) {
  const dispatch = useDispatch();
  const { id, property, contact_name, when } = visit;
  const { data } = useSelector((state) => state.UserSlice);
  const toolTipText = Trans(translations, 'ScheduledFor');
  const displayTime = getVisitScheduleDisplay(
    when,
    Trans(translations, 'Today'),
    data?.user_language
  );

  const handleClickVisit = () => {
    dispatch(toggleEditModal({ id, date: when }));

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  const handleQDOpen = (event) => {
    event.stopPropagation();

    if (property?.id) {
      dispatch(showQuickDisplay({ id: property.id }));

      if (trackCallback) {
        trackCallback(TRACK_ELEMENT.PROPERTY_ADDRESS);
      }
    }
  };

  return (
    <Box onClick={handleClickVisit} className={styles.visitsToConfirmCard}>
      <Box className={styles.propertyDataContainer}>
        {!property ? (
          <Text className={styles.noPropertyText}>
            {Trans(translations, 'NoAssociatedProperty')}
          </Text>
        ) : (
          <PropertyData
            picture={property.property_picture_url}
            address={property.address}
            location={property.location}
            id={property.id}
            onClick={handleQDOpen}
          />
        )}
      </Box>
      <Text className={styles.contactNameText}>{contact_name}</Text>
      <TimeStatusIndicator
        displayTime={displayTime}
        toolTipText={toolTipText}
        icon="icon-calendario"
      />
    </Box>
  );
}

export default VisitsToConfirmCard;
